/**
 * Landing path from BE role codes — no username hard-coding.
 * Production shells: /ops · /field · /exe · Ops BI persona (DEC-S7-011)
 */
export function landingPathForUser(
  roles: readonly string[] | readonly { code: string }[],
): string {
  const codes = roles.map((r) => (typeof r === "string" ? r : r.code));
  const set = new Set(codes.map((r) => r.toUpperCase()));

  if (set.has("ROLE_BGD")) return "/exe";
  if (set.has("ROLE_NV_SX") || set.has("ROLE_QC")) return "/field/home";
  if (set.has("ROLE_QA")) return "/ops/bi/quality";
  if (set.has("ROLE_KHO")) return "/ops/bi/warehouse";
  if (set.has("ROLE_QD") || set.has("ROLE_KE_HOACH")) return "/ops/bi/production";

  return "/ops";
}
